import { objectSpread2 as _objectSpread2 } from './_virtual/_rollupPluginBabelHelpers.mjs';
import React, { useContext } from 'react';
import { ThemeContext } from 'styled-components';
import { SizeWrapper, TouchWrapper } from './styles/styledComponents.mjs';
import { jsx } from 'react/jsx-runtime';

var Svg18Bookmark1 = /*#__PURE__*/React.memo(function (props) {
  useContext(ThemeContext);
  props.iconColor;
  var component = /*#__PURE__*/jsx("svg", _objectSpread2(_objectSpread2({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 18"
  }, props), {}, {
    children: /*#__PURE__*/jsx("path", {
      fill: props.iconColor ? props.iconColor : "#010505",
      fillRule: "evenodd",
      d: "m11.625 1.762-.05-.002h-5.48a2.27 2.27 0 0 0-1.601.77 2.25 2.25 0 0 0-.546 1.658L3.946 15.14l.006.1c.07.595.752.971 1.268.54l3.654-2.795 3.556 2.779.087.08c.514.404 1.169-.119 1.169-.724v-11c.085-1.187-.833-2.256-2.06-2.358zm-.078 1.198.092.013c.515.1.886.57.848 1.105l-.001 10.207-3.205-2.502a.78.78 0 0 0-.832.018l-3.303 2.526V4.14a1.1 1.1 0 0 1 .253-.822 1.05 1.05 0 0 1 .731-.359z"
    })
  }));
  if (props.size) {
    component = /*#__PURE__*/React.createElement(SizeWrapper, {
      size: props.size
    }, component);
  }
  if (props.touch) {
    component = /*#__PURE__*/React.createElement(TouchWrapper, {
      size: props.size,
      touch: props.touch
    }, component);
  }
  return component;
});
var Svg18Bookmark1$1 = Svg18Bookmark1;

export { Svg18Bookmark1$1 as default };
